export const formatMinutesToHoursMinutes = (
  timeString: string | number | undefined,
): string => {
  const timeInMinutes = parseInt(String(timeString), 10);
  if (isNaN(timeInMinutes)) return "Invalid time";

  const hours = Math.floor(timeInMinutes / 60);
  const minutes = timeInMinutes % 60;

  if (hours && minutes) return `${hours}h ${minutes}mins`;
  if (hours) return `${hours}h`;
  return `${minutes}mins`;
};
